// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__3FXyE","appTitle":"header_appTitle__1DLfq","appIcon":"header_appIcon__3lYSu"};